import styled from 'styled-components';
export const OnboardingWrapper = styled.div `
  /* min-height: calc(100% + ${({ theme }) => theme.space.space1200}); */
  scrollbar-width: none;
  -ms-overflow-style: none;
  display: flex;
  /* margin: -${({ theme }) => theme.space.space600}; */
  background-image: linear-gradient(#e9e9e9 1px, transparent 1px),
    linear-gradient(to right, #e9e9e9 1px, transparent 1px);
  background-size: 55px 55px;
  background-repeat: repeat;
  height: calc(100vh - 64px);
  position: absolute;
  pointer-events: none;
  z-index: 0;
  top: 0;
  left: 0;
  right: 0;
  flex: 1;
  overflow: hidden;
  align-items: center;justify-content: center;
  >* {
    flex: 1;
  }
`;
export const OnboardingAnim = styled.div `
  display: grid;
  gap: 0.05px;
  width: 100vw;
  height: calc(100vh - 64px)  ;
  overflow: hidden;
  position: fixed;
`;
export const OnboardingGridItem = styled.div `
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  border: 1px solid transparent;
  background-color: #93ffb0;
`;
export const OnboardingContent = styled.div `
  pointer-events: all;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin: auto;
  position: relative;
  width: 100%;
`;
